import type { InputCityProperties } from ".";
import { useDeferredValue, useMemo } from "react";
import { fuzzy_search_airport } from "@jetblue/fuzzy-search";

export const useFilteredItems = (
  inputValue: string,
  items: InputCityProperties["items"] = [],
) => {
  const deferredInputValue = useDeferredValue(inputValue);
  return useMemo(() => {
    const target = deferredInputValue.toLowerCase();
    return fuzzy_search_airport(target, items, 0.75).flatMap(
      ({ candidate: airport }) =>
        [
          airport,
          ...(airport.cc ?? []).map((a) => ({ ...a, indent: true })),
        ] as (typeof airport & { indent?: boolean })[],
    );
  }, [items, deferredInputValue]);
};
